import { render, staticRenderFns } from "./ConfirmOrDeniedDialog.vue?vue&type=template&id=4e8e7054&scoped=true"
import script from "./ConfirmOrDeniedDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmOrDeniedDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmOrDeniedDialog.vue?vue&type=style&index=0&id=4e8e7054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8e7054",
  null
  
)

export default component.exports